import { loadUserRoles } from '@/persistence/sessionStorage'
export const canAccess = route => {
  return (
    !route.meta.roles || route.meta.roles.some(r => loadUserRoles().includes(r))
  )
}
